import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { DailyForecastReportFormModel } from '../../models';

export const getDefaultValues = (
  globalSettings: GlobalSettingsModel
): DailyForecastReportFormModel => ({
  from: globalSettings?.frontend_date,
  to: globalSettings?.frontend_date,
  company: null,
  rates: [],
  roomTypeIds: null,
  gross_revenue: false,
  with_revenue: false,
  currency: null,
  currency_application: null,
  fixed_at: '',
  file_type: 'pdf',
});
